import React from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const NoticiaPost = ({ id, title, date }) => {
  return (
    <div className="noticias-post blackline2 hover">
      <Link to={`/noticia/${id}`}>
        <p>{title}</p>
      </Link>
      <p> {dayjs(date).format("DD/MM/YYYY")}</p>
    </div>
  );
};

export default NoticiaPost;
